import React, { useState, useEffect } from "react";
import "./CourseEnrollmentTermsAndConditions.scss";
import backBtn from "../../../../utilities/images/refer&earn/BackBtn.png";
import axios from "axios";
import { connect } from "react-redux";
import { url_186 } from "../../../../custom_utilities/api_services";

const CourseEnrollmentTermsAndConditions = ({
  handleOpenReferandEarn,
  token,
  tokenType,
}) => {
  const [data, setData] = useState({});

  const getTermsAndConditions = async () => {
    const headers = {
      Authorization: `${tokenType} ${token}`,
    };
    const queryParams = {
      name: "REFERRAL_TC",
      group: "TERMS_AND_CONDITIONS",
    };

    try {
      const response = await axios.get(url_186, {
        params: queryParams,
        headers: headers,
      });

      if (response.status === 200) {
        setData(response.data.data[0]);
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    getTermsAndConditions();
  }, []);

  return (
    <div className="termsAndConditions">
      <div className="container">
        <div className="sectionTitle">
          <div className="backBtnContent">
            <div className="backBtn" onClick={handleOpenReferandEarn}>
              <img src={backBtn} alt="backBtn" />
            </div>
            <strong>Terms & Conditions</strong>
          </div>
        </div>

        <div className="contentWrppr">
          <div className="content">
            {data && data.value && (
              <>
                <h2>{data.value.split("\r\n\r\n")[0]}</h2>
                <p>{data.value.split("\r\n\r\n")[1]}</p>
                <ul>
                  {data.value
                    .split("\r\n\r\n")
                    .slice(2)
                    .map((point, index) => (
                      <li key={index}>{point}</li>
                    ))}
                </ul>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    token: state.auth.authToken,
    tokenType: state.auth.authType,
  };
};

export default connect(
  mapStateToProps,
  null
)(CourseEnrollmentTermsAndConditions);
